import React, { useRef, useContext } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import useCloseOnClickAway from '../../shared/hooks/UseCloseOnClickAway'
import { WorkspaceContext } from './WorkspaceContext'
import { useParams } from 'react-router-dom'
import './qrcodepopup.scss'

const QrCodePopup = () => {
    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");

    const popupRef = useRef<HTMLDivElement | null>(null);

    const { roomId } = useParams();
    const shareableRoomUrl = roomId ? `${window.location.origin}/room/${roomId}` : '';

    useCloseOnClickAway({
        targetRef: popupRef,
        onClose: () => ctx.setQrPopup(false),
    });

    const entranceCode = ctx.roomDetails?.entranceCode ?? '';

    return (
        <div ref={popupRef} id='qr-code-popup' className='fade-in'>
            <div className='qr-top'>
                <h3>Join This Room</h3>

                <button className='ns-cancel' onClick={() => ctx.setQrPopup(false)}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>
            </div>

            <div className='qr-line' />

            <p className='qr-instructions'>Go to flash-room.com/join and enter this code:</p>

            <div className='sjm-c qr-code-repeat'>
                {entranceCode.split("").map((l, index) => (
                    <React.Fragment key={index}>
                        <div className='sjm-l'>
                            <p>{l}</p>
                        </div>

                        {(index === 2 || index === 4) && <span className="sjm-dash">-</span>}
                    </React.Fragment>
                ))}
            </div>

            {ctx.roomSettings.shareableLinkEnabled && (
                <>
                    <div className='qr-or-line'>
                        <span />
                        <p>or scan to join</p>
                        <span />
                    </div>

                    <div className='qr-code-frame'>
                        <QRCodeSVG value={shareableRoomUrl} size={180} />
                    </div>
                </>
            )}
        </div>
    )
}

export default QrCodePopup
